import GlobalFilter from 'components/GlobalFilter';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';

const TableActions = styled('div')({
  display: 'flex',
  gap: '10px',
})

const StyledToolbar = styled(Toolbar)({
  padding: 0,
  flexWrap: 'wrap',
  justifyContent: 'space-between',
})


export default function TableToolbar({
  numSelected,
  setGlobalFilter,
  globalFilter,
  total,
  SelectedActions,
  notSearched,
  gotoPage
}) {
  return (
    <StyledToolbar>
      {notSearched ? (
        <Typography>
          Enter your search parameters and click Search to return data by default.
        </Typography>
      ) : numSelected > 0 ? (
        <Typography>Selected {numSelected}</Typography>
      ) : (
        <Typography>{total} records found from your search criteria.</Typography>
      )}
      <TableActions>
        <GlobalFilter
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          gotoPage={gotoPage}
        />

        {SelectedActions}
      </TableActions>
    </StyledToolbar>

  )
};
